import React, { useEffect, useState } from "react";
import Spinner from "../../Spinner";
import ButtonSpinner from "../../ButtonSpinner";
import API_URL from '../../../utils/api';
import "../../Dashboard/View/Dashboard.css";
export default function IntelliMeJoinModal({ user, onSuccess, onClose }) {
  const [sessions, setSessions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState("");
  // Fetch available sessions
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await fetch(`${API_URL}/api/sessions`);
        const data = await response.json();
        // Parse members if needed
        const parsedData = data.map(s => ({
          ...s,
          members: typeof s.members === 'string' ? JSON.parse(s.members) : s.members,
          ready_users: typeof s.ready_users === 'string' ? JSON.parse(s.ready_users) : s.ready_users
        }));
        // Filter sessions that are still waiting/forming, not full, and created within last hour
        const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
        const availableSessions = parsedData.filter(s => {
          const createdAt = new Date(s.created_at);
          return (
            (s.status === 'waiting' || s.status === 'forming') && 
            (s.members || []).length < (s.max_participants || 6) &&
            createdAt > oneHourAgo // Only show sessions created within the last hour
          );
        });
        setSessions(availableSessions);
      } catch (err) {
        setError('Failed to load sessions');
      } finally {
        setLoading(false);
      }
    };
    fetchSessions();
    const interval = setInterval(fetchSessions, 5000); // Refresh every 5 seconds
    return () => clearInterval(interval);
  }, []);
  const handleJoin = async () => {
    if (!selected) return;
    setJoining(true);
    setError("");
    try {
      const response = await fetch(`${API_URL}/api/sessions/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: selected.id,
          userName: user.name || user.displayName,
          userId: user.id || user.uid
        })
      });
      const data = await response.json();
      if (response.ok) {
        // Navigate to lobby with session ID
        onSuccess(selected.id);
      } else {
        setError(data.message || 'Failed to join session');
      }
    } catch (err) {
      setError('Failed to join session. Please try again.');
    } finally {
      setJoining(false);
    }
  };
  return (
    <div className="dashboard-section">
      <h3>Join IntelliMe Session</h3>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '0.95rem' }}>
        Select an available session to join and meet new people!
      </p>
      {loading ? (
        <Spinner />
      ) : sessions.length === 0 ? (
        <div style={{ padding: '32px', textAlign: 'center', color: '#999' }}>
          <p>No available sessions at the moment.</p>
          <p style={{ fontSize: '0.9rem', marginTop: '8px' }}>
            Try creating your own session instead!
          </p>
        </div>
      ) : (
        <>
          <div style={{ marginBottom: '24px', maxHeight: '300px', overflowY: 'auto' }}>
            {sessions.map(s => (
              <div
                key={s.id}
                onClick={() => setSelected(s)}
                style={{
                  padding: '16px',
                  marginBottom: '12px',
                  border: selected?.id === s.id ? '2px solid #ff7b95' : '2px solid #ffe6eb',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  background: selected?.id === s.id ? '#fff5f8' : '#fff',
                  transition: 'all 0.2s ease'
                }}
              >
                <div style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: '4px' }}>
                  {s.name}
                </div>
                <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '8px' }}>
                  Host: {s.host}
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <span style={{
                    background: '#ff7b95',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '0.85rem',
                    fontWeight: 600
                  }}>
                    {s.participantCount || (s.members || []).length}/{s.max_participants || 6} joined
                  </span>
                  <span style={{ fontSize: '0.85rem', color: '#999' }}>
                    {new Date(s.created_at).toLocaleTimeString()}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <button 
            className="dashboard-btn" 
            onClick={handleJoin} 
            disabled={!selected || joining}
          >
            {joining ? <ButtonSpinner /> : "Join Selected Session"}
          </button>
        </>
      )}
      {error && <div className="dashboard-error" style={{ marginTop: '16px' }}>{error}</div>}
      <button className="dashboard-modal-close" onClick={onClose}>&times;</button>
    </div>
  );
}
